var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outer"},[_c('div',{staticClass:"inner bg-container"},[_c('b-container',{attrs:{"fluid":"xl"}},[_c('b-row',[_c('b-col',{staticClass:"top-content my-2",attrs:{"align-h":"start"}},[_c('router-view',{staticClass:"card-layout"})],1)],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }